import styled from 'styled-components'

export default styled.a`
  display: block;
  position: relative;
  top: ${props => props.top || '-122'}px;
  visibility: hidden;
`
